import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/close-icon-2.svg'
import _imports_1 from '@/assets/trash-icon-black.svg'


const _hoisted_1 = {
  key: 0,
  class: "w-full h-screen fixed top-0 left-0 bg-black/75 z-[1000]"
}
const _hoisted_2 = { class: "w-full max-w-[628px] min-h-[246px] px-[20px] fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-[7px] bg-white z-[1000]" }
const _hoisted_3 = { class: "flex items-center justify-between py-[16px] mb-[16px]" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "text-[20px] font-semibold text-[#393840]" }
const _hoisted_6 = { class: "max-h-[102px] text-[20px] pb-[6px] border-b border-[#E3E1EA] rounded-tl-[7px]" }
const _hoisted_7 = { class: "py-[16px] flex items-center justify-end gap-[16px]" }
const _hoisted_8 = { class: "text-[#393840]" }
const _hoisted_9 = { class: "min-w-[104px]" }

import { errorToast, successToast } from "@/utils/custom-toast";

import { useTranslate } from "@/composables/useTranslate";
import client from "@/utils/axios";

type Props = {
  isDeleteDialogOpen: boolean;
  bonusDate: any;
};

type Emits = {
  (event: "onClose"): void;
  (event: "decreaseDialogStage"): void;
  (event: "increaseDialogStage"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteReportConfirmDialog',
  props: {
    isDeleteDialogOpen: { type: Boolean },
    bonusDate: {}
  },
  emits: ["onClose", "decreaseDialogStage", "increaseDialogStage"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;
const { t } = useTranslate();

const handleClose = () => {
  emits("onClose");
};

const handleDelete = async () => {
  try {
    await client.delete("/installers/monthly-bonus/report", {
      data: {
        month: props.bonusDate.monthNumber,
        year: props.bonusDate.year,
      },
    });
    successToast(
      `${t("installers.delete_success").value} ${props.bonusDate.month}/${
        props.bonusDate.year
      }`
    );
    emits("onClose");
  } catch (error: any) {
    errorToast(error);
    console.log(error);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "nested" }, {
    default: _withCtx(() => [
      (__props.isDeleteDialogOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("global.delete")) + " " + _toDisplayString(__props.bonusDate.month?.trim()) + "/" + _toDisplayString(__props.bonusDate.year) + " " + _toDisplayString(_unref(t)("installers.monthly_bonus_report")), 1)
                ]),
                _createElementVNode("img", {
                  class: "h-[12px] w-[12px] cursor-pointer",
                  src: _imports_0,
                  alt: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClose()))
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", null, _toDisplayString(_unref(t)("installers.are_you_sure_delete")) + " " + _toDisplayString(__props.bonusDate.month?.trim()) + "/" + _toDisplayString(__props.bonusDate.year) + " " + _toDisplayString(_unref(t)("installers.monthly_bonus_report")) + "? ", 1),
                _createElementVNode("p", null, _toDisplayString(_unref(t)("installers.cannot_be_undone")) + ".", 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClose())),
                  class: "min-w-[79px] flex items-center justify-center p-[12px] text-[16px] text-white font-semibold border-2 border-[#393840] rounded-[7px]"
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)("global.cancel")), 1)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (handleDelete())),
                  class: "min-w-[154px] flex items-center text-nowrap p-[12px] gap-[8px] text-[16px] text-[#393840] font-semibold bg-[#F4B6B2] rounded-[7px]"
                }, [
                  _cache[3] || (_cache[3] = _createElementVNode("img", {
                    class: "w-[18px] h-[18px]",
                    src: _imports_1,
                    alt: ""
                  }, null, -1)),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)("installers.delete_report")), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})